const isFunction = (value) => typeof value === "function";
const __DEV__ = process.env.NODE_ENV !== "production";
const __TEST__ = process.env.NODE_ENV === "test";

export { __DEV__, __TEST__, isFunction };
//# sourceMappingURL=assertions.es.js.map
